export const LETTER_MATCHER = /[a-zA-Z]/g;
export const DIGIT_MATCHER = /\d/g;
export const SPECIAL_SYMBOL_MATCHER = /[`!@#$%^&*()_+\-=[\]{};':"|,.<>/?~]/g;
export const EMAIL_MATCHER = /.+@.+\..+/;
export const DEFAULT_PAGINATION_LIMIT = 25;
